import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

export default [
  trigger('drawerState', [
    state('open-left', style({ transform: 'translateX(0)' })),
    state('closed-left', style({ transform: 'translateX(-100%)' })),
    state('open-right', style({ transform: 'translateX(0)' })),
    state('closed-right', style({ transform: 'translateX(100%)' })),
    transition('* <=> *', [animate('300ms ease-in-out')])
  ]),
  trigger('backdropState', [
    state('open', style({ opacity: 1 })),
    state('closed', style({ opacity: 0 })),
    transition('open <=> closed', [animate('300ms ease-in-out')])
  ])
];
